var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('circle',{attrs:{"cx":"18","cy":"18","r":"17.5","transform":"rotate(-180 18 18)","stroke":"#F0933D"}}),_c('path',{attrs:{"d":"M21 12L15 18L21 24","stroke":"#F0933D"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }